export default "__VITE_ASSET__B$$IVR6d__"